import { SortParam } from '../sort-toggle/sort-toggle.component';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { HttpParams } from '@angular/common/http';
import { Page } from '../../../models/page.model';
import { Utils } from '../../../utils';

export abstract class AbstractListComponent<T, S> {

  currentPage = 1;
  searchParams: S;
  listItems: Page<T>;
  sortParams: SortParam | SortParam[];
  pageSize = Utils.defaultPageSize;

  protected getPage(page = 1) {
    const params = this.prepareParams(page);
    this.getListItems(params);
  }

  protected abstract getListItems(params: HttpParams);

  onDeletePageItem() {
    if (this.currentPage === 1) {
      this.getPage();
      return;
    }

    if (this.listItems.last && (this.listItems.numberOfElements === 1)) {
      --this.currentPage;
    } else {
      this.getPage(this.currentPage);
    }
  }

  onPageChanged(event: PageChangedEvent) {
    this.getPage(event.page);
  }

  onSearchItems(searchRequest: S) {
    this.searchParams = searchRequest;
    if (this.currentPage === 1) {
      this.getPage();
    } else {
      this.currentPage = 1;
    }
  }

  onSortList(sortParams) {
    this.sortParams = sortParams;
    this.getPage(this.currentPage);
  }

  onSizeSelected(size) {
    this.pageSize = size;
    this.getPage(this.currentPage);
  }

  protected prepareParams(page) {
    let params = new HttpParams();

    if (Array.isArray(this.sortParams)) {
      this.sortParams.forEach( param => {
        params = params.append('sort', [param.paramName, param.sortDirection].join(','));
      });
    } else {
      params = params.append('sort', [this.sortParams.paramName, this.sortParams.sortDirection].join(','));
    }
    params = params.append('page', (--page).toString());
    params = params.append('size', this.pageSize.toString());

    if (this.searchParams) {
      Object.keys(this.searchParams).forEach( key => {
        if (this.searchParams[key]) {
          params = params.append(key, `${this.searchParams[key]}`);
        }
      });
    }

    return params;
  }

}
